/*import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor() {}
}*/

import { Component, NgZone } from '@angular/core';

import { Platform, IonRouterOutlet } from '@ionic/angular';
//import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
//import { StatusBar } from '@ionic-native/status-bar/ngx';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SharedService } from './services/shared.service';
import { Connection } from './services/connection';
import { Places } from './services/places';
//import { Geolocation } from '@ionic-native/geolocation/ngx';
//import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';


import { PushNotifications, ActionPerformed, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { Badge } from '@awesome-cordova-plugins/badge/ngx';

import { Stripe } from '@capacitor-community/stripe';

import { Plugins } from '@capacitor/core';
import { Router } from '@angular/router';

import { URLOpenListenerEvent } from '@capacitor/app';

import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

const { App } = Plugins;



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

  constructor(
    private platform: Platform,
    private router: Router,
    private zone: NgZone,
    //private splashScreen: SplashScreen,
    //private statusBar: StatusBar,
    public sharedService: SharedService,
    public connection: Connection,
    public places: Places,
    //public geolocation: Geolocation,
    public routerOutlet: IonRouterOutlet,
    public badge: Badge,
    private screenOrientation: ScreenOrientation
  ) {
    this.initializeApp();

    if(this.sharedService.setup.env == 'remote') {
      Stripe.initialize({
        publishableKey: 'pk_live_51L4PkQCwBByVSh1PczkFWubKIWQ1sug2vZdMhcJtSvz1lNEsMgEIF56Nw31ONjgBboaQOpcgJCsrKxest3wDfuY100V6mjMHXp', //Publishable Key
        //TEST: pk_test_51L4PkQCwBByVSh1PzHjutU7MX5r0c3HYLZyNBp0M24gKZeU1EBr638F1ZiDr3eVm4Dq9Rm08ac40WjS2TWhD4PLv00F7lJS1Wf
        //PRODUCTION: pk_live_51L4PkQCwBByVSh1PczkFWubKIWQ1sug2vZdMhcJtSvz1lNEsMgEIF56Nw31ONjgBboaQOpcgJCsrKxest3wDfuY100V6mjMHXp
      });
    } else {
      Stripe.initialize({
        publishableKey: 'pk_test_51L4PkQCwBByVSh1PzHjutU7MX5r0c3HYLZyNBp0M24gKZeU1EBr638F1ZiDr3eVm4Dq9Rm08ac40WjS2TWhD4PLv00F7lJS1Wf', //Publishable Key
        //TEST: pk_test_51L4PkQCwBByVSh1PzHjutU7MX5r0c3HYLZyNBp0M24gKZeU1EBr638F1ZiDr3eVm4Dq9Rm08ac40WjS2TWhD4PLv00F7lJS1Wf
        //PRODUCTION: pk_live_51L4PkQCwBByVSh1PczkFWubKIWQ1sug2vZdMhcJtSvz1lNEsMgEIF56Nw31ONjgBboaQOpcgJCsrKxest3wDfuY100V6mjMHXp
      });
    }

  }

  initializeApp() {

    this.sharedService.setPlatform(this.platform);
    this.sharedService.setConnection(this.connection);
    this.sharedService.connection.setBaseUrl(this.sharedService.setup.baseurl[this.sharedService.setup.env]);
    this.sharedService.setPlaces(this.places);
    this.sharedService.places.setConnection(this.connection);

    this.platform.ready().then(() => {

      /*setTimeout(() => {
        alert(this.sharedService.currentLocation);
      }, 20000);*/

      /*App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const domain = 'vetibility.app';

        const pathArray = event.url.split(domain);
        // The pathArray is now like ['https://devdactic.com', '/details/42']

        // Get the last element with pop()
        const appPath = pathArray.pop();
        if (appPath) {
          //this.router.navigateByUrl(appPath);
        }
      });
    });*/

    this.sharedService.screenOrientation = this.screenOrientation.type;

    this.screenOrientation.onChange().subscribe(
       () => {
           console.log("Orientation Changed: " + this.screenOrientation.type);
           this.zone.run(() => {
             this.sharedService.screenOrientation = this.screenOrientation.type;
           });

       }
    );

    if(this.sharedService.isApp()) {
      PushNotifications.removeAllDeliveredNotifications();
      this.badge.clear();


      //this.statusBar.styleDefault();

      //determine if logged in

      //this.sharedService.setStorageItem('current_user', {username: 'testUser', remember_token: 'testToken'});

      // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
        PushNotifications.createChannel({ id: 'default', name: 'android', importance: 4}).then(() => {
          console.log('Channel created...');
        });
      } else {
        // Show some error
        console.error('Push permissions not granted...');
        if(this.sharedService.currentUser.type_id == 1) {
          this.sharedService.displayAcknowledgementIonAlert('You will need to enable Push Notifications in order to be notified of appointments in the Triage Queue as well as any changes to the status of an accepted appointment.');
        } else {
          this.sharedService.displayAcknowledgementIonAlert('You will need to enable Push Notifications in order to request appointments and be notified when a veterinarian has accepted your appointment.');
        }
      }
    });

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
      (token: Token) => {
        console.log('Push registration success, token: ' + token.value);
        this.sharedService.currentUser.device.token = token.value;

        this.sharedService.getStorageItem('deviceToken', (oldToken, component) => {

          //alert(this.shareService.getLocalStorage('deviceToken'));
          if(oldToken != null && oldToken != component.value) {
            //updated device token at server
            this.sharedService.updateDeviceToken(oldToken,component.value);
          }

          this.sharedService.setStorageItem('deviceToken',component.value);
          this.sharedService.currentUser.device.token = component.value;
        },
        (error, component) => {
          //alert('error getting storage item: ' + error);
          //console.error('Error getting deviceToken Storage Item... ' + JSON.stringify(error));
          console.log('Setting deviceToken Storage Item... ' + component.value);
          this.sharedService.setStorageItem('deviceToken',component.value);
          this.sharedService.updateDeviceToken(null,component.value);
        }, token);
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',
      (error: any) => {
        console.error('Error on registration: ' + JSON.stringify(error));
      }
    );

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.log('Push received: ' + JSON.stringify(notification));

        this.sharedService.refreshData().then(() => {
          this.sharedService.displayPushIonAlert(notification);
        });


      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        console.log('Push action performed: ' + JSON.stringify(notification));
        this.sharedService.refreshData().then(() => {
          if(notification.notification.data.appointment_id) {
            this.sharedService.apptResultStack.forEach(appointment => {
              if(appointment.appointment_id == notification.notification.data.appointment_id) {
                this.sharedService.navigateToAppointmentPage(appointment);
                return;
              }
            });
          }
        });

      }
    );
    }




    this.platform.backButton.subscribeWithPriority(-1, () => {
      console.log('Back button clicked.')
      if (!this.sharedService.canGoBack) {
        App.exitApp();
      }
    });

    this.platform.pause.subscribe(async () => {
      this.sharedService.foreground = false;
    });


    this.platform.resume.subscribe(async () => {

      this.sharedService.foreground = true;

      if(this.sharedService.isApp()) {
        PushNotifications.requestPermissions().then(result => {
          if (result.receive === 'granted') {
            console.log('Push permissions granted...');
            // Register with Apple / Google to receive push via APNS/FCM
            PushNotifications.register();
            PushNotifications.createChannel({ id: 'default', name: 'android', importance: 4}).then(() => {
              console.log('Channel created...');
            });
          } else {
            // Show some error
            console.error('Push permissions not granted...');
            if(this.sharedService.currentUser.type_id == 1) {
              this.sharedService.displayAcknowledgementIonAlert('You will need to enable Push Notifications in order to be notified of appointments in the Triage Queue as well as any changes to the status of an accepted appointment.');
            } else {
              this.sharedService.displayAcknowledgementIonAlert('You will need to enable Push Notifications in order to request appointments and be notified when a veterinarian has accepted your appointment.');
            }
          }
        });
      }


      //alert('resumed..');
      this.sharedService.authenticate().then(() => {
        this.sharedService.markAllPushAsSeen().then(() => {
          if(this.sharedService.isApp()) {
            PushNotifications.removeAllDeliveredNotifications();
            this.badge.clear();
            console.log('badge cleared...');
          }
          this.sharedService.updateLocation();
          //alert('badge cleared');

        });
      });

    });





      this.sharedService.getPresets();
      this.sharedService.getUserStartupData();


      /*//LOCATION START

      this.sharedService.configureLocationServices();


      //LOCATION END*/
    });
  }
}
